import { render } from "./TreinosView.vue?vue&type=template&id=33d9b1ec&scoped=true"
import script from "./TreinosView.vue?vue&type=script&lang=js"
export * from "./TreinosView.vue?vue&type=script&lang=js"

import "./TreinosView.vue?vue&type=style&index=0&id=33d9b1ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d9b1ec"]])

export default __exports__